import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { useAuth, api } from '../App';
import { Eye, EyeOff, Loader2 } from 'lucide-react';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', sifre: '' });
  const [loading, setLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const [beniHatirla, setBeniHatirla] = useState(() => localStorage.getItem('kc_remember') === '1');

  const submit = async e => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post('/auth/giris', { ...form, remember: beniHatirla });
      // Beni hatırla: 30 gün expiry bilgisini kaydet
      if (beniHatirla) {
        localStorage.setItem('kc_remember', '1');
        localStorage.setItem('kc_expire', String(Date.now() + 30 * 24 * 60 * 60 * 1000));
      } else {
        localStorage.removeItem('kc_remember');
        localStorage.removeItem('kc_expire');
      }
      login(data.token, data.kullanici);
      navigate('/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Giriş başarısız');
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = {
    width: '100%',
    padding: '11px 14px',
    border: '1.5px solid #e2e8f0',
    borderRadius: 10,
    fontSize: 14,
    fontFamily: 'inherit',
    outline: 'none',
    color: '#1e293b',
    background: '#fff',
    transition: 'border-color 0.15s, box-shadow 0.15s',
    boxSizing: 'border-box',
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(145deg, #1d4ed8 0%, #1e40af 40%, #1e3a8a 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 16,
      position: 'relative',
      overflow: 'hidden',
    }}>
      {/* Decorative circles */}
      <div style={{ position: 'absolute', width: 500, height: 500, borderRadius: '50%', background: 'rgba(255,255,255,0.04)', top: -150, right: -100, pointerEvents: 'none' }} />
      <div style={{ position: 'absolute', width: 350, height: 350, borderRadius: '50%', background: 'rgba(255,255,255,0.04)', bottom: -100, left: -80, pointerEvents: 'none' }} />

      <div style={{
        width: '100%',
        maxWidth: 400,
        background: '#fff',
        borderRadius: 20,
        padding: '36px 32px',
        boxShadow: '0 20px 60px rgba(0,0,0,0.25)',
      }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{ margin: '0 auto 14px', display: 'flex', justifyContent: 'center' }}>
            <img src="/logo.png" alt="temiz-iz.com" style={{ width: 80, height: 80, objectFit: 'contain', borderRadius: 16, boxShadow: '0 6px 20px rgba(29,78,216,0.20)' }} />
          </div>
          <h1 style={{ color: '#1e293b', fontSize: 20, fontWeight: 800, margin: '0 0 4px' }}>temiz-iz.com</h1>
          <p style={{ color: '#94a3b8', fontSize: 13, margin: 0 }}>Temizlik Yönetim Sistemi</p>
          <p style={{ color: '#64748b', fontSize: 12, margin: '4px 0 0', fontWeight: 500 }}>Yönetim Paneli</p>
        </div>

        <form onSubmit={submit}>
          <div style={{ marginBottom: 14 }}>
            <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#475569', marginBottom: 6 }}>
              E-posta Adresi
            </label>
            <input
              type="email" required
              value={form.email}
              onChange={e => setForm({ ...form, email: e.target.value })}
              placeholder="ornek@firma.com"
              style={inputStyle}
              onFocus={e => { e.target.style.borderColor = '#4a6cf7'; e.target.style.boxShadow = '0 0 0 3px rgba(74,108,247,0.12)'; }}
              onBlur={e => { e.target.style.borderColor = '#e2e8f0'; e.target.style.boxShadow = 'none'; }}
            />
          </div>

          <div style={{ marginBottom: 22 }}>
            <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#475569', marginBottom: 6 }}>
              Şifre
            </label>
            <div style={{ position: 'relative' }}>
              <input
                type={showPass ? 'text' : 'password'} required
                value={form.sifre}
                onChange={e => setForm({ ...form, sifre: e.target.value })}
                placeholder="••••••••"
                style={{ ...inputStyle, paddingRight: 44 }}
                onFocus={e => { e.target.style.borderColor = '#4a6cf7'; e.target.style.boxShadow = '0 0 0 3px rgba(74,108,247,0.12)'; }}
                onBlur={e => { e.target.style.borderColor = '#e2e8f0'; e.target.style.boxShadow = 'none'; }}
              />
              <button
                type="button" onClick={() => setShowPass(!showPass)}
                style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: '#94a3b8', padding: 4, display: 'flex', alignItems: 'center' }}
              >
                {showPass ? <EyeOff size={16} /> : <Eye size={16} />}
              </button>
            </div>
          </div>

          <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', marginBottom: 18 }}>
            <input
              type="checkbox"
              checked={beniHatirla}
              onChange={e => setBeniHatirla(e.target.checked)}
              style={{ width: 16, height: 16, accentColor: '#4a6cf7' }}
            />
            <span style={{ fontSize: 13, color: '#475569' }}>Beni hatırla (30 gün)</span>
          </label>

          <button
            type="submit" disabled={loading}
            style={{
              width: '100%', padding: '12px',
              background: loading ? '#93c5fd' : 'linear-gradient(135deg, #1d4ed8, #4a6cf7)',
              border: 'none', borderRadius: 10, color: '#fff',
              fontSize: 14, fontWeight: 700, cursor: loading ? 'not-allowed' : 'pointer',
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
              boxShadow: loading ? 'none' : '0 4px 14px rgba(29,78,216,0.35)',
              transition: 'all 0.15s', fontFamily: 'inherit',
            }}
          >
            {loading ? <Loader2 size={16} style={{ animation: 'spin 0.7s linear infinite' }} /> : null}
            {loading ? 'Giriş yapılıyor...' : 'Giriş Yap'}
          </button>
        </form>

        <p style={{ textAlign: 'center', marginTop: 24, fontSize: 11, color: '#cbd5e1' }}>
          © {new Date().getFullYear()} temiz-iz.com · Tüm hakları saklıdır
        </p>
      </div>
    </div>
  );
}
